import { render, staticRenderFns } from "./VFRTModal.vue?vue&type=template&id=2e6ab4e6&scoped=true"
import script from "./VFRTModal.vue?vue&type=script&lang=js"
export * from "./VFRTModal.vue?vue&type=script&lang=js"
import style0 from "./VFRTModal.vue?vue&type=style&index=0&id=2e6ab4e6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6ab4e6",
  null
  
)

export default component.exports